import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import MutualFunds from "@/pages/MutualFunds";
import FundDetail from "@/pages/FundDetail";
import Insurance from "@/pages/Insurance";
import Brokers from "@/pages/Brokers";
import ComparePage from "@/pages/ComparePage";
import SipCalculator from "@/pages/SipCalculator";
import RealEstate from "@/pages/RealEstate";
import Markets from "@/pages/Markets";
import ProjectDetail from "@/pages/ProjectDetail";
import AlertAction from "@/pages/AlertAction";
import JoinPartner from "@/pages/JoinPartner";
import AdminPage from "@/pages/AdminPage";
import ComingSoon, { HOLDING } from "@/pages/ComingSoon";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); document.title = "DhanTrove — Verified Investments for Indians"; }, [pathname]);
  return null;
};

function App() {
  if (HOLDING) return <ComingSoon />;
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/mutual-funds" element={<MutualFunds />} />
          <Route path="/mutual-funds/:code" element={<FundDetail />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/stock-brokers" element={<Brokers />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/sip-calculator" element={<SipCalculator />} />
          <Route path="/calculators" element={<SipCalculator />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/real-estate/project/:id" element={<ProjectDetail />} />
          <Route path="/alerts/:action/:token" element={<AlertAction kind="alerts" />} />
          <Route path="/digests/:action/:token" element={<AlertAction kind="digests" />} />
          <Route path="/join-partner" element={<JoinPartner />} />
          <Route path="*" element={<div data-testid="not-found-page" className="max-w-xl mx-auto px-4 py-24 text-center"><h1 className="font-display text-4xl font-extrabold">Page not found</h1><a href="/" className="inline-block mt-6 h-11 leading-[44px] px-6 rounded-xl bg-[#1E293B] text-white font-bold">Go to home</a></div>} />
        </Route>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
